import { createAction } from '@reduxjs/toolkit';

export const GET_CONDITION_QUERY_TEMPLATE = 'GET_CONDITION_QUERY_TEMPLATE';
export const CREATE_CONDITION_QUERY_TEMPLATE = 'CREATE_CONDITION_QUERY_TEMPLATE';
export const UPDATE_CONDITION_QUERY_TEMPLATE = 'UPDATE_CONDITION_QUERY_TEMPLATE';
export const SET_CURRENT_CONDITION_QUERY_TEMPLATE = 'SET_CURRENT_CONDITION_QUERY_TEMPLATE';
export const UNSET_CURRENT_CONDITION_QUERY_TEMPLATE = 'UNSET_CURRENT_CONDITION_QUERY_TEMPLATE';
export const CLEAR_CONDITION_QUERY_TEMPLATE_STORE = 'CLEAR_CONDITION_QUERY_TEMPLATE_STORE';
export const GET_PAGINATED_CONDITION_QUERY_TEMPLATES = 'GET_PAGINATED_CONDITION_QUERY_TEMPLATES';
export const GET_MINIMAL_CONDITION_QUERY_TEMPLATES = 'GET_MINIMAL_CONDITION_QUERY_TEMPLATES';

export const GETTING_CONDITION_QUERY_TEMPLATE = 'GETTING_CONDITION_QUERY_TEMPLATE';
export const GETTING_CONDITION_QUERY_TEMPLATE_FAILED = 'GETTING_CONDITION_QUERY_TEMPLATE_FAILED';
export const GETTING_CONDITION_QUERY_TEMPLATE_SUCCEEDED =
  'GETTING_CONDITION_QUERY_TEMPLATE_SUCCEEDED';

export const CREATING_CONDITION_QUERY_TEMPLATE = 'CREATING_CONDITION_QUERY_TEMPLATE';
export const CREATING_CONDITION_QUERY_TEMPLATE_SUCCEEDED =
  'CREATING_CONDITION_QUERY_TEMPLATE_SUCCEEDED';
export const CREATING_CONDITION_QUERY_TEMPLATE_FAILED = 'CREATING_CONDITION_QUERY_TEMPLATE_FAILED';

export const UPDATING_CONDITION_QUERY_TEMPLATE = 'UPDATING_CONDITION_QUERY_TEMPLATE';
export const UPDATING_CONDITION_QUERY_TEMPLATE_SUCCEEDED =
  'UPDATING_CONDITION_QUERY_TEMPLATE_SUCCEEDED';
export const UPDATING_CONDITION_QUERY_TEMPLATE_FAILED = 'UPDATING_CONDITION_QUERY_TEMPLATE_FAILED';

export const GETTING_PAGINATED_CONDITION_QUERY_TEMPLATES =
  'GETTING_PAGINATED_CONDITION_QUERY_TEMPLATES';
export const GETTING_PAGINATED_CONDITION_QUERY_TEMPLATES_SUCCEEDED =
  'GETTING_PAGINATED_CONDITION_QUERY_TEMPLATES_SUCCEEDED';
export const GETTING_PAGINATED_CONDITION_QUERY_TEMPLATES_FAILED =
  'GETTING_PAGINATED_CONDITION_QUERY_TEMPLATES_FAILED';

export const GETTING_MINIMAL_CONDITION_QUERY_TEMPLATES = 'GETTING_MINIMAL_CONDITION_QUERY_TEMPLATES';
export const GETTING_MINIMAL_CONDITION_QUERY_TEMPLATES_SUCCEEDED =
  'GETTING_MINIMAL_CONDITION_QUERY_TEMPLATES_SUCCEEDED';
export const GETTING_MINIMAL_CONDITION_QUERY_TEMPLATES_FAILED =
  'GETTING_MINIMAL_CONDITION_QUERY_TEMPLATES_FAILED';

export const GET_CONDITION_QUERIES = 'GET_CONDITION_QUERIES';
export const GETTING_CONDITION_QUERIES_SUCCEEDED = 'GETTING_CONDITION_QUERIES_SUCCEEDED';
export const GETTING_CONDITION_QUERIES_FAILED = 'GETTING_CONDITION_QUERIES_FAILED';

export const DELETE_CONDITION_QUERY = 'DELETE_CONDITION_QUERY';
export const DELETING_CONDITION_QUERY_SUCCEEDED = 'DELETING_CONDITION_QUERY_SUCCEEDED';
export const DELETING_CONDITION_QUERY_FAILED = 'DELETING_CONDITION_QUERY_FAILED';

export const RESET_SNACKBAR = 'RESET_SNACKBAR';
export const SET_NEXT_STEP = 'SET_NEXT_STEP';
export const UNSET_NEXT_STEP = 'UNSET_NEXT_STEP';

export const UPDATE_CONDITION_QUERY_FILTERS = 'UPDATE_CONDITION_QUERY_FILTERS';
export const RESET_CONDITION_QUERY_FILTERS = 'RESET_CONDITION_QUERY_FILTERS';

export const SET_COPY_CURRENT_CONDITION_QUERY_TEMPLATE = 'SET_COPY_CURRENT_CONDITION_QUERY_TEMPLATE';

export const getConditionQueryTemplate = createAction(GET_CONDITION_QUERY_TEMPLATE);

export const createConditionQueryTemplate = createAction(CREATE_CONDITION_QUERY_TEMPLATE);

export const updateConditionQueryTemplate = createAction(UPDATE_CONDITION_QUERY_TEMPLATE);

export const setCurrentConditionQueryTemplate = createAction(SET_CURRENT_CONDITION_QUERY_TEMPLATE);

export const unsetCurrentConditionQueryTemplate = createAction(
  UNSET_CURRENT_CONDITION_QUERY_TEMPLATE
);

export const clearConditionQueryTemplateStore = createAction(CLEAR_CONDITION_QUERY_TEMPLATE_STORE);

export const gettingConditionQueryTemplate = createAction(GETTING_CONDITION_QUERY_TEMPLATE);

export const gettingConditionQueryTemplateSucceeded = createAction(
  GETTING_CONDITION_QUERY_TEMPLATE_SUCCEEDED
);

export const gettingConditionQueryTemplateFailed = createAction(
  GETTING_CONDITION_QUERY_TEMPLATE_FAILED
);

export const creatingConditionQueryTemplate = createAction(CREATING_CONDITION_QUERY_TEMPLATE);

export const creatingConditionQueryTemplateSucceeded = createAction(
  CREATING_CONDITION_QUERY_TEMPLATE_SUCCEEDED
);

export const creatingConditionQueryTemplateFailed = createAction(
  CREATING_CONDITION_QUERY_TEMPLATE_FAILED
);

export const updatingConditionQueryTemplate = createAction(UPDATING_CONDITION_QUERY_TEMPLATE);

export const updatingConditionQueryTemplateSucceeded = createAction(
  UPDATING_CONDITION_QUERY_TEMPLATE_SUCCEEDED
);

export const updatingConditionQueryTemplateFailed = createAction(
  UPDATING_CONDITION_QUERY_TEMPLATE_FAILED
);

export const getPaginatedConditionQueryTemplates = createAction(
  GET_PAGINATED_CONDITION_QUERY_TEMPLATES
);

export const getMinimalConditionQueryTemplates = createAction(GET_MINIMAL_CONDITION_QUERY_TEMPLATES);

export const gettingMinimalConditionQueryTemplates = createAction(GETTING_MINIMAL_CONDITION_QUERY_TEMPLATES);
export const gettingPaginatedConditionQueryTemplates = createAction(
  GETTING_PAGINATED_CONDITION_QUERY_TEMPLATES
);
export const gettingPaginatedConditionQueryTemplatesSucceeded = createAction(
  GETTING_PAGINATED_CONDITION_QUERY_TEMPLATES_SUCCEEDED
);
export const gettingPaginatedConditionQueryTemplatesFailed = createAction(
  GETTING_PAGINATED_CONDITION_QUERY_TEMPLATES_FAILED
);
export const getConditionQueries = createAction(GET_CONDITION_QUERIES);
export const gettingConditionQueriesSucceeded = createAction(GETTING_CONDITION_QUERIES_SUCCEEDED);
export const gettingConditionQueriesFailed = createAction(GETTING_CONDITION_QUERIES_FAILED);

export const deleteConditionQuery = createAction(DELETE_CONDITION_QUERY);
export const deletingConditionQuerySucceeded = createAction(DELETING_CONDITION_QUERY_SUCCEEDED);
export const deletingConditionQueryFailed = createAction(DELETING_CONDITION_QUERY_FAILED);
export const resetSnackbar = createAction(RESET_SNACKBAR);
export const setNextStep = createAction(SET_NEXT_STEP);
export const unsetNextStep = createAction(UNSET_NEXT_STEP);

export const updateConditionQueryFilters = createAction(UPDATE_CONDITION_QUERY_FILTERS);
export const resetConditionQueryFilters = createAction(RESET_CONDITION_QUERY_FILTERS);

export const gettingMinimalConditionQueryTemplatesSucceeded = createAction(
  GETTING_MINIMAL_CONDITION_QUERY_TEMPLATES_SUCCEEDED
);

export const gettingMinimalConditionQueryTemplatesFailed = createAction(
  GETTING_MINIMAL_CONDITION_QUERY_TEMPLATES_FAILED
);

export const setCopyCurrentConditionQueryTemplate = createAction(
  SET_COPY_CURRENT_CONDITION_QUERY_TEMPLATE
);